import React from "react";
import Layout from "../../layout/Layout";
import { Card, Button, Typography, Result } from "antd";
import { BarChartOutlined, WarningOutlined } from "@ant-design/icons";

const { Title, Paragraph } = Typography;

const SystemMonitor = () => {
  return (
    <Layout>
      <div style={{ padding: "0 24px" }}>
        <div style={{ marginBottom: "24px" }}>
          <Title level={2}>System Monitor</Title>
          <Paragraph>Monitor real-time system performance and health metrics</Paragraph>
        </div>

        <Card style={{ textAlign: "center", minHeight: "500px" }}>
          <Result
            icon={<BarChartOutlined style={{ color: "#fa8c16", fontSize: "72px" }} />}
            title="System Monitoring Dashboard"
            subTitle="This page will contain real-time monitoring interfaces"
            extra={
              <div>
                <div style={{ marginBottom: "16px" }}>
                  <WarningOutlined style={{ color: "#fa8c16", marginRight: "8px" }} />
                  <span style={{ color: "#fa8c16" }}>Under Development</span>
                </div>
                <Paragraph style={{ color: "#666", marginBottom: "24px" }}>
                  The system monitor will provide real-time insights into KDS performance, 
                  network connectivity, and operational metrics.
                </Paragraph>
                <Button type="primary" disabled>
                  Coming Soon
                </Button>
              </div>
            }
          />
        </Card>
      </div>
    </Layout>
  );
};

export default SystemMonitor;
